import React, { useState } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const faqs = [{
  question: '¿Cómo recibo el Megapack después de comprar?',
  answer: 'En el momento en que confirmás el pago recibís un mail con el acceso a todos los materiales. No hay espera, no hay envío físico. Todo es digital y lo podés abrir desde el celular, la tablet o la computadora en menos de 5 minutos.'
}, {
  question: '¿Sirve si trabajo solo en consultorio privado o en un centro de rehabilitación?',
  answer: 'Está pensado principalmente para kinesiólogos independientes que trabajan solos o en consultorio pequeño. Todo el sistema de documentación, evoluciones y seguimiento está diseñado para que lo manejés vos sin depender de nadie más. Si trabajás en un centro también lo podés aplicar, pero el foco es la práctica autogestionada.'
}, {
  question: '¿Los materiales son editables?',
  answer: 'Sí. Los documentos vienen en formatos editables para que puedas poner tu nombre, logo y matrícula. Los checklists, evoluciones, consentimientos y contratos son tuyos para personalizar como necesites.'
}, {
  question: '¿Los 6 bonos están incluidos en las dos opciones?',
  answer: 'Los 6 bonos están incluidos en las dos opciones. Si además querés el sistema completo de gestión profesional, marca y escalabilidad — con el Método KINE-PRO™ — esa es la opción más inteligente para quienes quieren crecer de verdad.'
}, {
  question: '¿Sirve si soy recién recibido con poca experiencia clínica?',
  answer: 'Es ideal para eso. Todo está explicado con criterio clínico basado en evidencia pero en lenguaje aplicable desde el primer día. No asume que ya sabés todo — te da el marco para trabajar con seguridad aunque estés empezando a construir tu práctica independiente.'
}, {
  question: '¿Funciona para todas las áreas de la kinesiología?',
  answer: 'Los 6 tomos cubren traumatología y ortopedia, internación domiciliaria, neurología, geriatría, respiratorio y gestión clínica general. No es contenido genérico — es un sistema con criterio profesional real adaptable a tu área de trabajo.'
}, {
  question: '¿Qué pasa si atiendo pacientes con patologías complejas o de alto riesgo?',
  answer: 'El Tomo 2 de evaluación clínica incluye un apartado completo de banderas rojas y razonamiento clínico diferencial. El Bono de Blindaje Profesional además te da el marco legal y ético para documentar decisiones complejas con seguridad. No reemplaza el juicio clínico, pero lo estructura.'
}, {
  question: '¿Qué diferencia tiene con otros materiales de kinesiología del mercado?',
  answer: 'La mayoría de los materiales existentes son teóricos o están pensados para la formación académica. Este sistema está diseñado para la práctica real: protocolos listos para aplicar, plantillas de informes para Obras Sociales, sistema de cobro, retención y comunicación con el paciente. No es un libro — es una caja de herramientas lista para trabajar hoy.'
}, {
  question: '¿Por qué elegir el Megapack + Método KINE-PRO y no el estándar?',
  answer: 'El Megapack te da el sistema clínico completo. El Método KINE-PRO le agrega el sistema de negocio: cómo cobrar con abono mensual, cómo retener pacientes, cómo construir autoridad profesional y cómo escalar tu consultorio. Si querés trabajar mejor, el Megapack alcanza. Si querés además crecer y ganar lo que merecés, el Pro es la decisión obvia.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días desde el momento de la compra para revisarlo todo. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama. La tasa de devolución es menor al 1% — no porque no se pueda pedir, sino porque el material habla por sí solo.'
}];
export function FAQ() {
  useTrackSection('faq', 'FAQ Section');
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(235,248,255) 0%, rgb(255,255,255) 10%, rgb(255,255,255) 85%, rgb(235,248,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-136">
      <div className="mx-auto max-w-4xl" data-id="element-137">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-138">
          Preguntas{' '}
          <span style={{
          color: '#0077B6'
        }} data-id="element-139">
            frecuentes
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-140">
          Todo lo que necesitás saber antes de decidir.
        </p>

        {/* Accordion */}
        <div className="flex flex-col gap-2" data-id="element-141">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="bg-white rounded-xl overflow-hidden shadow-sm" style={{
            border: isOpen ? '1px solid rgba(0,119,182,0.50)' : '1px solid rgba(0,119,182,0.15)',
            transition: 'border-color 0.2s ease'
          }} data-id="element-142">
                {/* Question */}
                <button onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-5 py-4 m-0" style={{
              fontFamily: 'inherit'
            }} data-id="element-143">
                  <span className="text-sm font-bold transition-colors duration-200" style={{
                color: isOpen ? '#0077B6' : '#111827'
              }} data-id="element-144">
                    {i + 1}. {faq.question}
                  </span>
                  <span className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-white text-base font-black" style={{
                backgroundColor: '#0077B6',
                transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                transition: 'transform 0.3s cubic-bezier(0.25,0.46,0.45,0.94)'
              }} data-id="element-145">
                    +
                  </span>
                </button>

                {/* Answer — animated */}
                <div style={{
              display: 'grid',
              gridTemplateRows: isOpen ? '1fr' : '0fr',
              transition: 'grid-template-rows 0.35s cubic-bezier(0.25,0.46,0.45,0.94)'
            }} data-id="element-146">
                  <div style={{
                overflow: 'hidden'
              }} data-id="element-147">
                    <div className="px-5 pb-4 pt-3" style={{
                  borderTop: '1px solid rgba(0,119,182,0.10)'
                }} data-id="element-148">
                      <p className="text-sm text-gray-600 leading-relaxed m-0" data-id="element-149">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}